import {Input} from 'react-bootstrap'
import React from 'react'
import {request} from '../../helpers/request'
import {t} from '../../helpers/translate'
import StaticTextComponent from './StaticTextComponent'
import BaseInputComponent from './BaseInputComponent'
let config = require('config');

class DropdownComponent extends BaseInputComponent {

  fetchData(url) {
    request(`${config.default.api}/${this.props.optionsUrl}`, 'GET', null, this.getOptionsFromUrl.bind(this));
    return [];
  }

  getOptionsFromUrl(responseData, statusCode) {
    if (statusCode == 200) {
      this.props.updateOptions(this.props.savedOptionsState, responseData)
    }
  }

  getOptions() {
    let savedOptions = this.props.getSavedOptions(this.props.savedOptionsState)
    return savedOptions ? savedOptions : this.fetchData(this.props.optionsUrl);
  }

  render() {
    let value = this.getValue();
    const options = this.props.optionsUrl ? this.getOptions() : this.props.options.slice();

    if (this.props.isStatic) {
      let text = '';
      if (value === '00' && this.props.keyPath.indexOf('country_of_origin') !== -1 ) {
          options.push({text: t('Not Available'), value: '00'});
      }
      for (let option of options) {
        if (option.value == t(value)) {
          text = t(option.text);
        }
      }
      return <StaticTextComponent id={this.props.id} value={text}/>
    }

    if (this.props.keyPath.indexOf('country_of_origin') !== -1) {
      options.push({text: t('Not Available'), value: '00'});
    }

    return <div className={`form-group ${this.state.isInvalid ? 'has-error' : ''}`}>
      <Input 
        id={this.props.id} type="select" 
        defaultValue={this.props.defaultValue ? this.props.defaultValue : value} 
        value={value || ''}
        onChange={(event) => {this.handleChange(event.target.value)}}
      >
        {this.props.hideNullOption === true ? null : <option key={-1} disabled value="">---</option>}
        {options.map((item, i) => <option key={i} value={item.value}>{t(item.text)}</option>)}
      </Input>
    </div>
  }
}
DropdownComponent.displayName = 'DropdownComponent';
export default DropdownComponent;



// WEBPACK FOOTER //
// ./src/components/common/DropdownComponent.js